module.exports = function negotiateAddClass(element, className, shouldAdd) {
    if(shouldAdd) // TODO: ADD TESTS
        element.classList.add(className);
    else
        element.classList.remove(className);
}
